import { render, staticRenderFns } from "./commissions-container.vue?vue&type=template&id=2d86ea72"
import script from "./commissions-container.vue?vue&type=script&lang=js"
export * from "./commissions-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports